import * as constAction from 'root/actionConstants';

/**
* Setea un campo o el reducer completo del componente con el default.
* @param {string} value Nombre del campo a limpiar ("all" para todo el reducer).
* @returns {Object}
*/
export const clear = value => ({
  type: constAction.MAPAGEN_CLEAR,
  payload: value
});

/**
* Setea un campo en el reducer .
* @param {Object} values - Campos a setear.
* @param {string} values.* - Nombre y valor del campo a setear.
* @returns {Object}
*/
export const setState = values => ({
  type: constAction.MAPAGEN_SET_STATE,
  payload: values
});



// WEBPACK FOOTER //
// src/modules/mapaGeneral/action.js